var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Payment',{staticClass:"mb-2"}),_c('div',{staticClass:"checkout-rounded-container"},[_c('Influencer'),(_vm.hasDish)?_c('Tip',{staticClass:"mb-5"}):_vm._e(),_c('Card')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }